export default __webpack_public_path__ + "static/illustration-content-desc.url-57057dedb7321029b0a7e1df0408342a.svg";